import { combineReducers } from '@reduxjs/toolkit'
import { SendEmailReducer } from './email'
import sendMessageReducer from './message'
import messageRecipients from './recipients'
import { SendSmsReducer } from './sms'

export default combineReducers({
  email: SendEmailReducer,
  sms: SendSmsReducer,
  recipients: messageRecipients,
  message: sendMessageReducer,
})
